import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VList,{staticClass:"soli-lesson-types"},_vm._l((_vm.appTypes),function(app){return _c(VListItem,{key:app.name},[_c('SoliBtn',{attrs:{"block":"","text":app.name,"color":"contrast--text","outlined":"","disabled":app.disabled},on:{"click":function($event){return _vm.$emit('input', app)}}})],1)}),1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }